import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import { TopicId } from '~/dashboard/utils/learningPath.utils'
import CertificateItem from '~/statistics-v2/components/CertificateItem'
import { MasteryCertificatesProgressProps } from '~/statistics-v2/types/statistics.types'

export default function MasteryCertificatesProgress({
  certificates,
}: MasteryCertificatesProgressProps): React.ReactElement | null {
  const { t } = useTranslation('statisticsV2')
  const [displayAll, setDisplayAll] = useState(false)

  if (certificates.length === 0) {
    return null
  }

  return (
    <div className="flex min-w-full gap-2 justify-center items-center">
      <div
        className={`self-start flex flex-col justify-between p-6 w-87.5 lg:w-full border rounded-6 border-white/5 bg-purple-plum overflow-hidden transition-all duration-1000 ease-in-out ${
          displayAll ? 'max-h-270' : 'max-h-56'
        }`}
      >
        <div className="flex justify-between items-start">
          <div className="flex flex-col">
            <h2 className="text-white text-md font-bold flex items-center gap-2">🏆 {t('masteryCertificates')}</h2>
            <span className="text-blue-pastel text-xs">
              {certificates.filter((c) => c.isCompleted).length} / {certificates.length} {t('collected')}
            </span>
          </div>
          <button
            className="text-white text-xs font-medium hover:text-blue-pastel transition-colors"
            onClick={() => setDisplayAll(!displayAll)}
          >
            {displayAll ? t('seeLess') : t('seeAll')}
          </button>
        </div>
        <div className="flex flex-wrap items-start mt-8 gap-x-4 lg:gap-x-12 gap-y-9 justify-center">
          {certificates.map((certificate) => (
            <CertificateItem
              badgeSrcKey={`curriculum/certificate/mastery-certificate-${
                certificate.topicSlug ?? TopicId.NUMBERS
              }_v4.png`}
              date={certificate.completionDate}
              isLocked={!certificate.isCompleted}
              key={certificate.topicId}
              title={certificate.topicName}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
